<template>
  <modal :modal-key="'resubscribe_with_pin'" class="modal--welcomeback modal--zero-balance " @close="close()">
    <template slot="header">
      <h1 v-if="!alreadySubmittedUser"> {{ getTranslations.home_modals_profile_email_thank_you_congratulations }} </h1>
      <h1 v-else> {{ getTranslations.home_modals_profile_email_thank_you_already_verified }} </h1>
      <img v-if="!alreadySubmittedUser" class="pinicon mt-1" src="static/images/bonus_points.svg" alt="">
      <img v-else class="pinicon mt-1" src="static/images/email_already_verified.svg" alt="">
    </template>
    <template slot="body">
      <p class="mt-3 mb-lg-4" v-if="!alreadySubmittedUser"> {{ getTranslations.home_modals_profile_email_thank_you_you_have }} {{ getTranslations.home_modals_profile_email_thank_you_games_earned }} {{ getTranslations.home_modals_profile_email_thank_you_games_and }} {{ getTranslations.home_modals_profile_email_thank_you_points_earned }} {{ getTranslations.home_modals_profile_email_thank_you_points }}
      </p>


    </template>
  </modal>
</template>

<script>
import Modal from '@/components/home/modals/shared/GenericModal';
import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'email-success',
  components: {
    Modal,
  },
  beforeDestroy() {
    this.clearEmailVerification();
    this.updateEmailVerified(true);
    this.updateShowThankYouEmailModal(false);
  },
  methods: {
    ...mapMutations('common', [
      'updateEmailVerified',
      'clearEmailVerification',
    ]),
    ...mapMutations('profile', [
      'updateShowThankYouEmailModal',
    ]),
    close() {
      this.updateEmailVerified(true);
      this.clearEmailVerification();
      this.updateShowThankYouEmailModal(false);
      this.$emit('close');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslationByOperator',
      'getTranslations',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('profile', [
      'alreadySubmittedUser',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/profile/EmailSuccess.vue